import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function TransitionStatement() {
  return (
    <section
      data-testid="transition-statement"
      className="relative z-20 border-t border-[#2A2A2A] bg-[#0B0B0B] py-28 md:py-40"
    >
      <div className="max-w-[1100px] mx-auto px-6 flex flex-col items-center text-center">
        <motion.span
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mb-10 block h-px w-16 origin-center bg-[#1F7A4D]"
        />
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE, delay: 0.1 }}
          className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.9] tracking-[0.02em]"
        >
          Where Football Lives<span className="text-[#1F7A4D]">.</span>
        </motion.h2>
      </div>
    </section>
  );
}
